/* eslint-disable no-debugger */

import { ColorService } from '@tableau/vizportalclient-common-components';

export function applyColor(color: string, defaultColor: string, debug?: boolean) {
    if (debug) {
        debugger;
    }
    return ColorService.instance.applyColor(color, defaultColor);
}